import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Deterministic placeholder gradient for a module with no uploaded image.
 *
 * The hue is derived from the title, so two modules in the same course never
 * come out identical — which is exactly what inheriting the course thumbnail
 * would have done. It stays inside a violet→teal arc around the brand hue
 * (302) rather than spanning the full wheel, so the fallbacks read as a family
 * instead of as a random palette.
 */
export function titleGradient(seed: string): string {
  let hash = 0
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0
  }
  const hue = 195 + (Math.abs(hash) % 130) // 195..324
  return `linear-gradient(135deg, oklch(0.62 0.13 ${hue}) 0%, oklch(0.46 0.15 ${
    (hue + 28) % 360
  }) 100%)`
}

export function fmtSeconds(s: number): string {
  const total = Number.isFinite(s) ? Math.max(0, Math.floor(s)) : 0
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const sec = total % 60
  if (h > 0) {
    return `${h}:${m.toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")}`
  }
  return `${m}:${sec.toString().padStart(2, "0")}`
}
